import React from 'react';
import {
  Box,
  Grid,
  Button,
  Typography,
  useTheme,
  alpha,
} from '@mui/material';
import { format } from 'date-fns';
import {
  AccessTime as TimeIcon,
} from '@mui/icons-material';

const TimeSlotGrid = ({ 
  timeSlots, 
  selectedTime, 
  onTimeSelect,
  isMobile,
  disabled = false
}) => {
  const theme = useTheme();
  
  // Simple click handler that doesn't manipulate the DOM directly
  const handleTimeClick = (time, event) => {
    // Prevent default to avoid any page jumps
    event.preventDefault();
    
    // Call the selection handler provided by parent
    if (!disabled) {
      onTimeSelect(time);
    }
  };

  return (
    <Grid container spacing={2}>
      {timeSlots.map((time, index) => {
        // Simple equality check based on timestamp
        const isSelected = selectedTime && 
          selectedTime.getTime() === time.getTime();
        
        return (
          <Grid item xs={6} sm={4} md={3} key={index}>
            <Button
              fullWidth
              variant={isSelected ? "contained" : "outlined"}
              onClick={(e) => handleTimeClick(time, e)}
              disabled={disabled}
              sx={{
                height: '48px',
                borderColor: isSelected ? 'transparent' : alpha(theme.palette.primary.main, 0.3),
                color: isSelected ? 'white' : theme.palette.text.primary,
                backgroundColor: isSelected ? theme.palette.primary.main : 'transparent',
                '&:hover': {
                  borderColor: isSelected ? 'transparent' : theme.palette.primary.main,
                  backgroundColor: isSelected 
                    ? theme.palette.primary.main 
                    : alpha(theme.palette.primary.main, 0.04),
                },
                transition: 'background-color 0.2s, color 0.2s, border-color 0.2s',
                position: 'relative',
                overflow: 'hidden',
                padding: '6px 8px',
              }}
            >
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                whiteSpace: 'nowrap',
                width: '100%',
                justifyContent: 'center',
              }}>
                <TimeIcon sx={{ fontSize: 18, flexShrink: 0 }} />
                <Typography variant="body2" noWrap component="span">
                  {format(time, 'h:mm a')}
                </Typography>
              </Box>
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
};

// Use React.memo to prevent unnecessary re-renders
export default React.memo(TimeSlotGrid); 